// TwitterCallback.tsx
import { useEffect } from 'react';
import { useBackendApi } from '../../helpers/backendHelper';

const TwitterCallback = () => {
  const backendHelper = useBackendApi();

  useEffect(() => {
    backendHelper.refreshAccessToken().then(response => {
      if (window.opener) {
        window.opener.postMessage(
          {
            type: 'TWITTER_AUTH_SUCCESS',

            user: response.data,
          },
          '*',
        );
        window.close();
      }
    });
  }, []);

  return <p>Logging in with Twitter...</p>;
};

export default TwitterCallback;
